export default __webpack_public_path__ + "images/vkinverse.9ca1dba9.svg";